import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  filterItem: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      flexBasis: '50%',
    },
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
    },
    '& > div': {
      width: '100%',
    },
  },
}));
